import React from "react";
import { useEffect, useState } from "react";

const useEmpListAssignRewards = (empArr, handleSelectedEmp) => {
  const [trow, setTrow] = useState([]);
  const [thead] = useState([
    "Id",
    "Name",
    "Project",
    // "email",
    // "mobile",
    // "join date",
    // "role",
    // "action",
  ]);

  useEffect(() => {
 
       
    let trow =empArr && empArr.map((employee, i) => {
      // console.log("empArr",empArr)
       return {
         Id: <div>{employee.employeeId}</div>,
 
         Name: (
           <h2
           className="table-avatar"
             onClick={() => handleSelectedEmp(employee)}
           >
             <img
               className="profile-img-table"
               alt=""
               src={employee.profilePicture == null || employee.profilePicture == "null" || employee.profilePicture =='undefined'? (require(`../../../img/employee/user.png`)) : (`https://niraconnect.nirasystems.com:8080/wwwroot/UploadedPhotos/ProfilePicture/${employee.profilePicture}`)}
               
             />
             <span className="ml-2">
               <span style={{ fontWeight: "400", color: "black" }}>
                 {employee.employeeName === null ? "" :employee.employeeName}
               </span>
               <span> {employee.designationName}</span>
             </span>
           </h2>
         ),
         Project: (
           employee.projectList.filter( (ele, ind) => ind === employee.projectList.findIndex( elem => elem.projectID === ele.projectID)).map(
             (member, i) => (
               <span key={member.projectID}>
               <small>{member.projectName},</small>
  
             </span>  
             )
           )
                
        
          ),
       };
     })  

    setTrow(trow);
  }, [empArr, handleSelectedEmp]);

  return { thead, trow };
};

export default useEmpListAssignRewards;

// <table cellspacing="0" cellpadding="0" border="0" width="325">
//       <tr>
//         <td>
//           <Table hover style={{ margin: "0px" }} {...getTableProps()} striped className="mt-2">
//             <thead>
//   {headerGroups.map((headerGroup, p) => (
//     <tr key={p} {...headerGroup.getHeaderGroupProps()}>
//       {headerGroup.headers.map((column) => (
//         <th {...column.getHeaderProps(column.getSortByToggleProps())}>
//           {column.render("Header")}
//           {/* Add a sort direction indicator */}
//           <span className="">
//             <i className="fas fa-exchange-alt fa-rotate-90 ml-3"></i>
//             {/* {column.isSorted ? (
//               column.isSortedDesc ? (
//                 " 🔽"
//               ) : (
//                 " 🔼"
//               )
//             ) : (
//               <i className="fas fa-exchange-alt fa-rotate-90"></i>
//             )} */}
//           </span>
//         </th>
//       ))}
//     </tr>
//   ))}
// </thead>
//           </Table>
//         </td>
//       </tr>
//       <tr>
//         <td>
//           <div style={{ width: "500px", height: "180px", overflow: "auto" }}>
//             <Table hover>
// <tbody {...getTableBodyProps()}>
// {page.map((row, i) => {
//   prepareRow(row);
//   return (
//     <tr key={i} {...row.getRowProps()}>
//       {row.cells.map((cell, k) => {
//         return (
//           <td key={k} {...cell.getCellProps()}>
//             {cell.render("Cell")}
//           </td>
//         );
//       })}
//     </tr>
//   );
// })}
// </tbody>
//             </Table>
//            </div>
//          </td>
//        </tr>
//      </table>
